module.exports = __webpack_public_path__ + "img/Salon.44225ead.svg";